import { renderLayerDom } from '@/utils/render-kit';
import { type ILayerProps, type IVectorLayerProps } from '@/version-types';
import { checkIsUsingEffect } from '../utils/effect';
import ImageContent from './image-content';
import VectorLayer from './vector-layer';

export const renderDom = (identity: string, layer: ILayerProps): Promise<() => void> => {
    return new Promise((resolve) => {
        // 判断是否有特效
        const layerData = layer.data as IVectorLayerProps;
        const isUsingEffect = checkIsUsingEffect(layerData, {
            includeBlur: true,
        });

        const dispose = renderLayerDom(
            isUsingEffect ? (
                <VectorLayer
                    identity={identity}
                    isNavigator={false}
                    layer={layer}
                    onRenderEnd={() => {
                        resolve(dispose);
                    }}
                />
            ) : (
                <ImageContent
                    identity={identity}
                    isNavigator={false}
                    layer={layer}
                    onRenderEnd={() => {
                        resolve(dispose);
                    }}
                />
            ),
        );
    });
};
